<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-17 11:54:10
 * @Description: 备案信息
 -->

<template>
  <div class="records-info-wrapper">
    <el-row class="row">
      <el-col :span="12" class="col col-left">公信部备案编号：</el-col>
      <el-col :span="12" class="col col-right">
        <a href="http://www.miit.gov.cn/">闽ICP备14014561号-2</a>
      </el-col>
    </el-row>
    <el-row class="row is-even">
      <el-col :span="12" class="col col-left">备案登记信息：</el-col>
      <el-col :span="12" class="col col-right">
        <p>
          备案登记地方金融监管部门：申请中<br />
          备案登记时间：申请中<br />
          备案登记编号：申请中
        </p>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col :span="12" class="col col-left">电信业务经营许可证号：</el-col>
      <el-col :span="12" class="col col-right">
        <span>申请中</span>
      </el-col>
    </el-row>
    <el-row class="row is-even">
      <el-col :span="12" class="col col-left">资金存管信息：</el-col>
      <el-col :span="12" class="col col-right">
        <!-- <a href="http://www.ybccb.com/CN/index.html">
          <img src="https://files.jinr.com/jinr-index/img/logo-bank.png" alt="" />
          <i>存管银行股份有限公司</i>
        </a> -->
        宜宾市商业银行
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col :span="12" class="col col-left">公安机关核发的网站备案图标及编号：</el-col>
      <el-col :span="12" class="col col-right">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo">
          <img src="https://files.jinr.com/jinr-index/img/logo-police.png" alt="" />
          <i>闽公网安备 35020302000866号</i>
        </a>
      </el-col>
    </el-row>

    // <el-row class="row is-even">
    //   <el-col :span="12" class="col col-left">信息安全等级保护：</el-col>
    //   <el-col :span="12" class="col col-right"><span>申请中</span></el-col>
    // </el-row>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.records-info-wrapper {
  .row {
    .col {
      display: flex;
      align-items: center;
      height: 90px;
      padding: 0 20px;
      a {
        color: #247af1;
        display: flex;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .span {
        color: #6c6c6c;
      }
    }
    .col-left {
      justify-content: flex-end;
    }
  }
  .row.is-even {
    background: #fafafa;
  }
}
</style>
